import { render } from "./App.vue?vue&type=template&id=55207ce0&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=55207ce0&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=55207ce0&lang=css"

import exportComponent from "/Users/nakakita/Desktop/work/_private/diffpdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55207ce0"]])

export default __exports__